<template>
  <div class="blue-circle">
    <a href="https://t.me/dmitry_zaikins" rel="noopener" target="_blank">
      <img src="https://cdn.icon-icons.com/icons2/3685/PNG/512/telegram_logo_icon_229299.png" alt="Telegram Icon" class="telegram-icon">
    </a>
    <div class="popup-message">
      <p>Есть баги или предложения? Пиши сюда.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlueCircle',
  data() {
    return {
      showPopup: false
    };
  },
  methods: {
    togglePopup() {
      this.showPopup = !this.showPopup;
    }
  }
};
</script>

<style scoped>
.blue-circle {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color:  rgb(43 43 43 / 80%);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #414141;
  z-index: 999;
}

.telegram-icon {
  width: 25px;
  height: 25px;
  margin: 13px 11px;
}

.popup-message {
  display: none;
  position: absolute;
  width: 180px;
  top: -90px;
  left: 70%;
  transform: translateX(-120%);
  background-color: #282828;
  padding: 10px;
  border-radius: 5px;
  
}

.popup-message p{
  margin: 0;
}

.blue-circle:hover .popup-message {
  display: block;
}
</style>